<template>
  <div class="cooperate">
    <!-- //表格内容 -->
    <div class="content-wrapper">
      <div class="content-info">
        <el-table
          ref="table"
          stripe
          :data="tableData.list"
          :header-cell-style="{backgroundColor:'#f5f7fa'}"
          style="width: 100%;margin: 10px 0;"
        >
          <el-table-column
            v-for="(item,index) in tableHeader"
            :key="index"
            :prop="String(index)"
            :label="item"
          ></el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="tc mt20">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(search.page)"
          :page-size="Number(search.size)"
          layout="total, prev, pager, next"
          :total="Number(tableData.count)"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>


<script>
import { _userRegistration } from "@/api/user";

export default {
  created() {
    this.initInfoList();
  },
  props:{
    user_id:{
      type:String
    }
  },
  computed:{
  },
  data() {
    return {
      search: {
        page: 1,
        size: 10,
        keywords: ""
      },
      courseData: [],
      tableData: {
         list:[],
         count:''
      },
      tableHeader: []
    };
  },
  methods: {
    inportData() {
      if(this.keywords&&this.tableData.list.length>0){
         window.open(`/admin/excel/collect?course_id=${this.keywords}`,'_self')
      }
    },
    seachStatus(val) {
      this.initInfoList();
    },
    // 请求求合作内容的列表,锁定课程，2，求合作的表单
    initInfoList() {
        // form_mode: 1,锁定课程，2，求合作的表单
      let data = {
        page: this.search.page,
        size: this.search.size,
        user_id: this.user_id
      };
      if (!data.user_id) {
        delete data.user_id;
      }
      _userRegistration({
        params: data
      }).then(res => {
        // console.log(res.result);
        if (res.resultCode == 1) {
          var data = { ...res.result };
          let titles = data.titles;
          let values = data.values;
          this.tableHeader=titles.map(item=>{
            return item.form_control_name;
          })

          let info = values.map(item => {
            let newItem = titles.map(tit => {
              if (Array.isArray(tit)) {
                return "--";
              }
              return item[Number(tit.form_control_id)]
                ? item[Number(tit.form_control_id)]
                : "--";
            });
            return newItem;
          });
          this.tableData.list = info;
          this.tableData.count=res.result.count
        } else {
          tiis.$message.error(res.errorMsg);
        }
      });
    },
    handleCurrentChange(val) {
      this.search.page=val;
      this.initInfoList();
    }
  }
};
</script>


<style lang="less" scoped>
.seach {
  .seach-list {
    .input-v {
      margin-right: 20px;
    }
    .input-sea {
      margin-left: 20px;
      width: 280px;
      border-radius: 5px;
    }
  }
}
</style>